/**
 * Точки входа в N-03 (CLIENT_WEB.md §8.1 п. 2): первый match, первое открытие
 * чата, S-04 и первый запуск установленного Web App.
 *
 * Из них автоматическими являются только первые две, поэтому здесь же
 * действует ограничение «не при каждом запуске»: предложение показывается
 * один раз и запоминается в реплике (UiKey.seenHints).
 *
 * Автоматическое предложение — не модальное окно, а полоса над списком
 * (`PushOfferBar`): окно поверх только что открытого чата перебивало
 * переписку. Модальное объяснение остаётся для явных действий (S-04,
 * первый запуск установленного Web App).
 */
import { hintsRepo } from '@shared/db'
import { pushState } from '@shared/push'

import { useAppStore } from './app-store'

export async function offerPushPrompt(): Promise<void> {
  const store = useAppStore.getState()
  if (store.pushPromptOpen || store.pushOfferOpen) return

  // §8.1 п. 3–4: при `denied` и отключённом канале предлагать нечего.
  if (pushState(store.config) !== 'prompt') return

  try {
    if (await hintsRepo.wasSeen('push_prompt')) return
    await hintsRepo.markSeen('push_prompt')
  } catch {
    // Реплика ещё не открыта — лучше не показать, чем показать дважды.
    return
  }

  useAppStore.getState().openPushOffer()
}
